angular.module('Directives').directive('bbaAddressInput', function () {
    return {
        restrict: 'E',
        scope: {
            country: '=',
            postcode: '=',
            suburb: '=',
            state: '=',
            style: '<'
        },
        templateUrl: '/templates/directives/bbaAddressInput.html'
    };
});



// WEBPACK FOOTER //
// ./js/directives/bbaAddressInput.js